module.exports = __webpack_public_path__ + "media/images/pen-604257e5e0b8f02be30c00c94b4bd87d.svg";